import React from 'react';
import type { AthleteProps, BracketProps, BracketRoundProps, PlayerBracketPickProps, RoundEventProps, TeamProps } from '../../../types';
import RoundEventCard from './RoundEvent';
import { view_styles } from '../../../constants/styles';
import { Button, Text, View } from '../../../Components/Themed';
import { Checkbox, Icons } from '../../../Components';
import { useColors } from '../../../constants/useColors';

type BracketRoundSectionProps = {
    player_bracket_id?:string,
    round_event_loading?:string,
    player_bracket_picks: PlayerBracketPickProps[],
    bracket_round:BracketRoundProps,
    selected?:boolean,
    bracket?:BracketProps,
    round_events:RoundEventProps[],
    compact?:boolean,
    teams:TeamProps[],
    pick_status?:'complete'|'incomplete'
    athletes:AthleteProps[],
    hide_titles?:boolean,
    width:number,
    orientation:'left'|'right',
    onSelectRound:(bracket_round:BracketRoundProps) => void,
    onSelectContest?:(round_event:RoundEventProps, player_bracket_pick?:PlayerBracketPickProps, away_placeholder_pick?:PlayerBracketPickProps, home_placeholder_pick?:PlayerBracketPickProps) => void
    active_bracket_group_id?:string,
    onPick: (player_bracket_pick:PlayerBracketPickProps) => void,
    left_bar?:boolean,
    right_bar?:boolean
}

const BracketRoundSection = ({ bracket_round, compact, orientation, selected, pick_status, bracket, round_event_loading, teams, round_events, width, hide_titles, player_bracket_picks, active_bracket_group_id, onSelectContest, onSelectRound, onPick }:BracketRoundSectionProps) => {
    const Colors = useColors();
    if(active_bracket_group_id){
        round_events = round_events.filter(re => re.bracket_group_id == active_bracket_group_id)
    }

    const renderRoundEvents = (data: { item:RoundEventProps, index:number}) => {
        const player_bracket_pick = player_bracket_picks.find(pbr => pbr.round_event_id == data.item.round_event_id);
        const away_placeholder_pick = player_bracket_picks.find(pbr => pbr.round_event_id == data.item.away_placeholder);
        const home_placeholder_pick = player_bracket_picks.find(pbr => pbr.round_event_id == data.item.home_placeholder);
        const away_placeholder_team = teams.find(t => t.team_id == away_placeholder_pick?.pick_side_id)
        const home_placeholder_team = teams.find(t => t.team_id == home_placeholder_pick?.pick_side_id)

        const home_team = teams.find(t => t.team_id == data.item.home_side_id);
        const away_team = teams.find(t => t.team_id == data.item.away_side_id);
        const loading = round_event_loading == data.item.round_event_id ? true : false
        return (
            <View key={`${data.item.bracket_id}_${data.item.round_event_id}`} transparent style={{ margin:4, marginTop:13, flex:1, flexGrow:1, justifyContent:'center' }}>
                <View transparent style={{ margin:1, ...view_styles.float }}>
                    <RoundEventCard
                        round_event={data.item}
                        loading={loading}
                        round_events={round_events}
                        away_team={away_team}
                        bracket={bracket}
                        compact={compact}
                        orientation={orientation}
                        home_team={home_team}
                        away_placeholder_team={away_placeholder_team}
                        home_placeholder_team={home_placeholder_team}
                        player_bracket_pick={player_bracket_pick}
                        width={width}
                        no_pick={bracket_round.carry_through ? true : false}
                        away_placeholder_pick={away_placeholder_pick}
                        home_placeholder_pick={home_placeholder_pick}
                        onPick={(player_bracket_pick) => {
                            if(bracket_round.carry_through){ return alert('Event is not eligible for picks') }
                            onPick(player_bracket_pick)
                        }}
                        onSelectContest={onSelectContest}
                    />
                </View>
            </View>
        )
    }


    return (
        <View key={`${bracket_round.bracket_id}_${bracket_round.bracket_round_id}`} transparent style={{ minWidth: width }}>
            {!hide_titles ?
            <View transparent style={{ borderBottomWidth:selected?2:1, borderColor:selected?Colors.text.action:Colors.borders.light, margin:3 }}>
                <Button type='text' style={{ flexDirection:'row', alignItems:'center', padding:10 }} onPress={() => onSelectRound(bracket_round)}>
                    <View style={{ flexDirection:'row', alignItems:'center', flex:1 }}>
                        <Checkbox checked={selected} color={Colors.text.action} disabled size={18} style={{ borderRadius:100 }} fill_style={{ borderRadius:100 }} onSelect={() => console.log('')} />
                        <Text style={{ marginLeft:10 }} size={14} theme='h1' textAlign="center">{bracket_round.round_name}</Text>
                    </View>
                    {pick_status == 'complete' ?
                    <Icons.CheckCirlceIcon color={Colors.text.success} size={14} />
                    :
                    <Icons.AlertIcon color={Colors.text.warning} size={14} />
                    }
                </Button>
            </View>
            :<></>}
            <View transparent nativeID="round_events" style={{ flex:1 }}>
                {round_events.filter(re => re.bracket_round_id == bracket_round.bracket_round_id).sort((a,b) => a.event_number - b.event_number).map((re, i) => {
                    return renderRoundEvents({ item: re, index:i })
                })}
            </View>
        </View>
    )
}

export default BracketRoundSection